export default __webpack_public_path__ + "static/media/logi_6-min.b6ab1032.jpg";